import { render, staticRenderFns } from "./AlarmRecord.vue?vue&type=template&id=fe36fee8"
import script from "./AlarmRecord.vue?vue&type=script&lang=js"
export * from "./AlarmRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports